import { auth } from '@sagano/admin/stores';
import ShareAuth from '@sagano/share/vendors/firebase';

const adminAuth = new ShareAuth(auth);

export const storage = adminAuth.storage;
export default adminAuth;
